'use client';

import type { ReactNode } from 'react';
import { AuthProvider } from '@/hooks/useAuth';
import type { RuntimeAuthConfig } from '@/lib/auth/types';

export interface AuthWrapperProps {
  children: ReactNode;
  config: RuntimeAuthConfig;
}

/**
 * Client component wrapper that receives runtime auth config from Server Components
 * and passes it to the AuthProvider.
 */
export function AuthWrapper({ children, config }: AuthWrapperProps) {
  return (
    <AuthProvider config={config}>
      {children}
    </AuthProvider>
  );
}
